import { baseApiClient } from "data/modules/api/api.client";
import { GENERATE_HASH_KEY_API } from "../SSE.constants";
import { logError } from "utils/error";

export const generateHashKey = async () => {
  try {
    const response = await baseApiClient.get(GENERATE_HASH_KEY_API, {
      baseURL: `${process.env.REACT_APP_SSE_API_BASE_URL}/`, // overriding the baseURL
    });
    return response?.data?.data;
  } catch (error) {
    logError({
      error,
      when: "generateHashKey",
      occuredAt: "src/data/modules/SSE/utils/generateHashKey.js",
    });
  }
};
